import { Component, inject } from '@angular/core'
import { PageHeaderComponent } from '../page-header/page-header.component'
import { PageContentComponent } from '../page-content/page-content.component'
import { ErdFileUploaderComponent } from './erd-file-uploader.component'
import { ExpectedResultsService, UploadResponse } from 'src/app/shared/services/expected-results.service'
import { Observable } from 'rxjs'

const rxJoin = (regExps: readonly RegExp[]): RegExp =>
  new RegExp(regExps.map(_ => _.source).join(''))

@Component({
  selector: 'app-import-erd',
  imports: [
    PageHeaderComponent, 
    PageContentComponent,
    ErdFileUploaderComponent,
  ],
  styles: `
    app-page-content {
      padding-top: 2rem;
    }
  `,
  template: `
    <div app-page-header header="Expected Results Data"></div>
    <app-page-content>
      <app-erd-file-uploader 
          name="Active Generation Units" 
          [validationRegExp]="generationLoadValidationRegexp"
          [upload]="generationLoadUpload"
      />
      <app-erd-file-uploader
          name="Ties" 
          [validationRegExp]="tiesValidationRegExp"
          [upload]="rpgiUpload"
      />
      <app-erd-file-uploader
          name="System Load" 
          [validationRegExp]="systemLoadValidationRegExp"
          [upload]="systemLoadUpload"
      />
    </app-page-content>
  `,
})
export class ImportErdComponent {
  private readonly expectedResultsService = inject(ExpectedResultsService)

  protected readonly generationLoadValidationRegexp = rxJoin([
    /^Report Dates:,\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}-\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2},{25}[\s\S]+/,
    /,{26}[\s\S]+/,
    /,{26}[\s\S]+/,
    /,{26}[\s\S]+/,
    /,{2}Hour,{24}[\s\S]+/,
    /Date,MapMDMAGen,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,Total[\s\S]+/,
  ])

  protected readonly tiesValidationRegExp = rxJoin([
    /^Report Dates:,\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}-\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2},{25}[\s\S]+/,
    /,{26}[\s\S]+/,
    /,{26}[\s\S]+/,
    /,{26}[\s\S]+/,
    /,{3}Hour,{23}[\s\S]+/,
    /Description,Date,Total,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24[\s\S]+/,
  ])

  protected readonly systemLoadValidationRegExp = rxJoin([
    /^Report Dates:,\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}-\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2},{25}[\s\S]+/,
    /,{26}[\s\S]+/,
    /,{26}[\s\S]+/,
    /,{26}[\s\S]+/,
    /,{2}Hour,{24}[\s\S]+/,
    /Date,Description,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,Total[\s\S]+/,
  ])

  protected readonly generationLoadUpload = (file: File): Observable<UploadResponse> =>
    this.expectedResultsService.generationLoad(file)

  protected readonly rpgiUpload = (file: File): Observable<UploadResponse> =>
    this.expectedResultsService.rpgiLoad(file)

  protected readonly systemLoadUpload = (file: File): Observable<UploadResponse> =>
    this.expectedResultsService.systemLoad(file)
}
